import createType, { AbstractType } from './type'
import { InferNative } from './type'

export type ArrayBase = Array<any>

export interface ArrayType<NativeShapeGeneric extends ArrayBase | null = ArrayBase>
  extends AbstractType<NativeShapeGeneric> {
  readonly type: 'array'
  readonly content: AbstractType<any>
  readonly currentValue?: NativeShapeGeneric
  isRequired(): ArrayType<Exclude<NativeShapeGeneric, null>>
  isOptional(): ArrayType<NativeShapeGeneric | null>
}

export default function array<
  NativeGeneric extends Array<NativeGeneric>,
  ContentTypeGeneric extends AbstractType,
  InferredContent = InferNative<ContentTypeGeneric>,
>(contentType: ContentTypeGeneric): ArrayType<Array<InferredContent>> {
  return {
    ...createType<ArrayType<Array<InferredContent>>>(),
    type: 'array',
    content: contentType,
  }
}
